module.exports = __webpack_public_path__ + "img/cooperative@1x.6079e06c.png";